exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".negativeInfo {\n  font-size: 14px;\n  color: #9e9e9e; }\n\n.infoLabel {\n  margin-top: 10px;\n  display: table; }\n\n.infoIcon {\n  width: 40px;\n  text-align: center;\n  font-size: 20px;\n  margin-right: 6px; }\n\n.priority-3 {\n  color: green; }\n\n.priority-2 {\n  color: orange; }\n\n.priority-1 {\n  color: red; }\n\n.iconEnabled {\n  color: #3A81F5; }\n\n.iconDisabled {\n  color: #8e8c8c; }\n\n.infoContainer {\n  padding: 15px 15px 20px 15px;\n  color: #565656;\n  font-size: 14px; }\n\n.infoTitle {\n  font-size: 13px;\n  font-weight: bold; }\n\n.vertical-middle {\n  vertical-align: middle; }\n\n.download-button {\n  width: 100%;\n  background-color: #3A81F5;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/comunicacion-detail/comunicacion-detail.component.scss
// module id = ../../../../../src/app/components/comunicaciones/comunicacion-detail/comunicacion-detail.component.scss
// module chunks = 0